import { injectable } from 'inversify'
import type { Resolvable } from '@/services/resolvers/types'
import { loadScript } from '@/utils/script'

export type ScriptResolverServiceParams = {
  src: string
  attributes?: Record<string, string>
  disableUnresolve?: boolean
}

@injectable()
export default class ScriptResolverService implements Resolvable<ScriptResolverServiceParams> {
  public async resolve(params: ScriptResolverServiceParams) {
    await this.load(params)
  }

  public async unresolve(params: ScriptResolverServiceParams) {
    await this.unload(params)
  }

  protected async load({ src, attributes }: ScriptResolverServiceParams) {
    await loadScript(src, attributes)
  }

  protected unload({ src, disableUnresolve }: ScriptResolverServiceParams) {
    if (disableUnresolve) {
      return Promise.resolve()
    }

    return new Promise((resolve) => {
      const el = document.querySelector(`script[src="${src}"]`)

      if (!el) {
        resolve(false)
        return
      }

      document.head.removeChild(el)

      resolve(true)
    })
  }
}
